import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=284c869e"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports